import { ControlSource } from './device'
import { ECommanderModeLostAction, ECommanderModeLostActionMap, ERthMode, ERthModeMap, ECommanderFlightMode, ECommanderFlightModeMap, LostControlActionInCommandFLight, LostControlActionInCommandFLightMap, WaylineLostControlActionInCommandFlight } from '/@/api/drone-control/drone'

export enum ControlSourceChangeType {
  Flight = 1,
  Payload = 2,
}

// 控制权变化消息
export interface ControlSourceChangeInfo {
  sn: string,
  type: ControlSourceChangeType,
  control_source: ControlSource
}

// 飞向目标点结果
export interface FlyToPointMessage {
  sn: string,
  result: number,
  message: string,
}

// 一键起飞结果
export interface TakeoffToPointMessage {
  sn: string,
  result: number,
  message: string,
}

// 设备端退出drc模式
export interface DrcModeExitNotifyMessage {
  sn: string,
  result: number,
  message: string,
}

// 飞行控制模式状态
export interface DrcStatusNotifyMessage {
  sn: string,
  result: number,
  message: string,
}

export const WaylineLostControlActionInCommandFlightOptions = [
  { label: 'Continue', value: WaylineLostControlActionInCommandFlight.CONTINUE },
  { label: 'Execute Lost Action', value: WaylineLostControlActionInCommandFlight.EXEC_LOST_ACTION }
]

export const LostControlActionInCommandFLightOptions = [
  { label: LostControlActionInCommandFLightMap[LostControlActionInCommandFLight.RETURN_HOME], value: LostControlActionInCommandFLight.RETURN_HOME },
  { label: LostControlActionInCommandFLightMap[LostControlActionInCommandFLight.HOVER], value: LostControlActionInCommandFLight.HOVER },
  { label: LostControlActionInCommandFLightMap[LostControlActionInCommandFLight.Land], value: LostControlActionInCommandFLight.Land }
]

// 返航模式设置值 {"0":"智能高度","1":"设定高度"}
export const RthModeInCommandFlightOptions = [
  { label: ERthModeMap[ERthMode.SMART], value: ERthMode.SMART },
  { label: ERthModeMap[ERthMode.SETTING], value: ERthMode.SETTING }
]

// 指点飞行失控动作{"0":"继续执行指点飞行任务","1":"退出指点飞行任务，执行普通失控行为"}
export const CommanderModeLostActionInCommandFlightOptions = [
  { label: ECommanderModeLostActionMap[ECommanderModeLostAction.CONTINUE], value: ECommanderModeLostAction.CONTINUE },
  { label: ECommanderModeLostActionMap[ECommanderModeLostAction.EXEC_LOST_ACTION], value: ECommanderModeLostAction.EXEC_LOST_ACTION }
]

// 指点飞行模式设置值{"0":"智能高度飞行","1":"设定高度飞行"}
export const CommanderFlightModeInCommandFlightOptions = [
  { label: ECommanderFlightModeMap[ERthMode.SMART], value: ECommanderFlightMode.SMART },
  { label: ECommanderFlightModeMap[ERthMode.SETTING], value: ECommanderFlightMode.SETTING }
]

// 云台重置模式
export enum GimbalResetMode {
  Recenter = 0,
  Down = 1,
  RecenterGimbalPan = 2,
  PitchDown = 3,
}

export const GimbalResetModeMap = {
  [GimbalResetMode.Recenter]: '回中',
  [GimbalResetMode.Down]: '向下',
  [GimbalResetMode.RecenterGimbalPan]: '偏航回中',
  [GimbalResetMode.PitchDown]: '俯仰向下'
}

// 重置模式类型 {"0":"回中","1":"向下","2":"偏航回中","3":"俯仰向下"}
export const GimbalResetModeOptions = [
  { label: GimbalResetModeMap[GimbalResetMode.Recenter], value: GimbalResetMode.Recenter },
  { label: GimbalResetModeMap[GimbalResetMode.Down], value: GimbalResetMode.Down },
  { label: GimbalResetModeMap[GimbalResetMode.RecenterGimbalPan], value: GimbalResetMode.RecenterGimbalPan },
  { label: GimbalResetModeMap[GimbalResetMode.PitchDown], value: GimbalResetMode.PitchDown }
]

/** 红外-调色盘 */
export const ThermalCurrentPaletteStyleArr = {
  0: '白热',
  1: '黑热',
  2: '描红',
  3: '医疗',
  5: '彩虹 1',
  6: '铁红',
  8: '北极',
  11: '熔岩',
  12: '热铁',
  13: '彩虹 2'
}
